var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3125 0.8125H0.6875C0.376367 0.8125 0.125 1.06387 0.125 1.375V12.625C0.125 12.9361 0.376367 13.1875 0.6875 13.1875H15.3125C15.6236 13.1875 15.875 12.9361 15.875 12.625V1.375C15.875 1.06387 15.6236 0.8125 15.3125 0.8125ZM14.6094 2.76016V11.9219H1.39062V2.76016L0.905469 2.38223L1.59629 1.49453L2.34863 2.07988H13.6531L14.4055 1.49453L15.0963 2.38223L14.6094 2.76016ZM13.6531 2.07812L8 6.47266L2.34687 2.07812L1.59453 1.49277L0.903711 2.38047L1.38887 2.7584L7.39355 7.42715C7.56624 7.56131 7.77869 7.63413 7.99736 7.63413C8.21604 7.63413 8.42849 7.56131 8.60117 7.42715L14.6094 2.76016L15.0945 2.38223L14.4037 1.49453L13.6531 2.07812Z",
    fill: "#8C8C8C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.a327eb7bc3cebe9f8e353bfe6b97b439.svg";
export { ForwardRef as ReactComponent };